"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = genMaxMin;
var _cssinjs = require("@ant-design/cssinjs");
function genMaxMin(type) {
  if (type === 'js') {
    return {
      max: Math.max,
      min: Math.min
    };
  }
  return {
    max: function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return `max(${args.map(value => (0, _cssinjs.unit)(value)).join(',')})`;
    },
    min: function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return `min(${args.map(value => (0, _cssinjs.unit)(value)).join(',')})`;
    }
  };
}